import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import TeamSeasonShirtsPanels from './Panels';

@injectIntl
export default class TeamSeasonShirts extends Component {
  render() {
    const {
      teamSeasons = [],
      intl: { messages: m },
    } = this.props;
    return (
      <div>
        <Toolbar>
          <Typography variant="h6">{m.app_teamSeasonShirtsList}</Typography>
        </Toolbar>
        <div style={{ padding: 16 }}>
          <TeamSeasonShirtsPanels teamSeasons={teamSeasons} />
        </div>
      </div>
    );
  }
}
